module.exports = __webpack_public_path__ + "static/media/valor3.6a23446b.png";